
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[state]",
      function () {
        return require("private-next-pages/sitemap/[state]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[state]"])
      });
    }
  